var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{attrs:{"height":"4.75rem"}},_vm._l((_vm.list),function(item){return _c('el-carousel-item',{key:item.imageUrl},[_c('img',{staticClass:"banner-img",attrs:{"src":item.imageUrl}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }